const Form086EN = {
    stepName: {
        statement: "Important Notes",
        school: "School Information",
        student: "Student Contestants",
        teacher: "Personal Particulars of Coach Teacher",
        confirmation: "Confirmation",
    },
    errorMsg: {
        min4: "Each team consists of 4 students",
        max2: "At most two secondary 2 students in each team",
    },
    label: {
        note: "Notes",
        statement: "Personal Information Collection Statement",
        certify:
            "I have read, understood and agreed to the above terms and conditions",
        eligibility: "Eligibility",
        schoolNameE: "Name of School (English)",
        schoolNameC: "Name of School (Chinese)",
        schoolTel: "School Telephone Number",
        schoolFax: "School Fax Number",
        nameEnglish: "Name in English",
        nameChinese: "Name in Chinese",
        level: "Level",
        mobile: "Mobile Number",
        email: "E-mail address",
        startDate: "Start date of current school year",
        endDate: "End date of current school year",
        deadline: "Deadline",
        date: "Date of current school year",
        nil: ' (Please fill in "NIL" if not available)',
    },
    levelValue: {
        secondary1: "Secondary 1",
        secondary2: "Secondary 2",
    },

    noteList: [
        {
            text: "The personal data provided in this form will be used by the Education Bureau for the purposes of processing applications for the competition, liaison and compiling statistics.",
        },
        {
            text: "The provision of personal data by means of this form is obligatory. Failure to provide these data may affect the processing and outcome of your application.",
        },
        {
            text: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
        },
        {
            text: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance. Your right of access includes the right to obtain a copy of your personal data provided in this form. This is however subject to payment of a fee.",
        },
        {
            text: 'Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be addressed to the Gifted Education Section of the Education Bureau via email (<a href="mailto: exoge@edb.gov.hk">exoge@edb.gov.hk</a>).',
        },
        {
            text: 'The EDB is committed to ensuring all personal data to be handled in accordance with the relevant provisions of the Personal Data (Privacy) Ordinance. For details, please refer to the "<a style="color: blue" href="https://www.edb.gov.hk/attachment/en/about-edb/info/privacy-statement/EDB_PDPO_e.pdf" target="_blank" rel="noopener noreferrer">Education Bureau - Statement of Privacy Policy and Practices</a>"',
        },
        {
            text: 'For enquiries, please contact Mr Terence LO on 3698 3493 or email to <a href="mailto: cdoge6@edb.gov.hk">cdoge6@edb.gov.hk</a>.',
        },
        {
            text: 'Schools shall inform students and their parents / guardians that in the course of the competition, the EDB and persons / parties authorised by the EDB may take photographs and videos which the student may appear in. The photographs and videos may be used for publicity purposes by the EDB in print or digitally. Schools or parents / guardians who have any concern about the arrangement may write to <a href="mailto: cdoge6@edb.gov.hk">cdoge6@edb.gov.hk</a>.',
        },
    ],
    eligibilityList: [
        {
            text: "1. Each school can only send one team to participate in the competition.",
        },
        {
            text: "2. Each team consists of 4 students.",
        },
        {
            text: "3. Secondary 1 to 2 students are eligible to the competition with at most two secondary 2 students in each team.",
        },
    ],
};
export default Form086EN;
